import { render, staticRenderFns } from "./corp_info.vue?vue&type=template&id=1177a1fd&scoped=true&"
import script from "./corp_info.vue?vue&type=script&lang=js&"
export * from "./corp_info.vue?vue&type=script&lang=js&"
import style0 from "./corp_info.vue?vue&type=style&index=0&id=1177a1fd&scoped=true&lang=less&"
import style1 from "./corp_info.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1177a1fd",
  null
  
)

export default component.exports